import { set as setCookie } from 'js-cookie';
import { useMemo } from 'react';

import { useLoggedInEmployeeId, useLoggedInUserRoles } from '~/components/Auth';
import { useModulesConfig } from '~/data/company';
import { Roles } from '~/data/user';

import { checkModuleActiveBasedOnConfig } from './checkModuleActiveBasedOnConfig';
import { COOKIE_ANALYTICS_ID, COOKIE_ANALYTICS_NUM } from './constants';

export interface UseAppModulesOutput {
  employeeId: number;
  userRoles: Roles[];
  isModuleActive: (module: string) => boolean;
  setNavigationForDashboard: (navSelector: string) => string;
}

// TODO This hook should probably be moved to ~/data/modules
export const useAppModules = () => {
  const employeeId = useLoggedInEmployeeId();
  const { enabledModules } = useModulesConfig();
  const userRoles = useLoggedInUserRoles();
  const isModuleActive = useMemo(
    () => checkModuleActiveBasedOnConfig(enabledModules, userRoles),
    [enabledModules, userRoles],
  );
  const setNavigationForDashboard = (navSelector: string) => () => {
    setCookie(COOKIE_ANALYTICS_NUM, '0');
    setCookie(COOKIE_ANALYTICS_ID, navSelector);
  };

  return {
    employeeId,
    userRoles,
    isModuleActive,
    setNavigationForDashboard,
  };
};
